import React from 'react'
import moment from 'moment'
import api from './Api'

RegExp.escape = function(s) {
  const str = JSON.stringify(s)
  const escaped = str.substring(1, str.length - 1)
  // eslint-disable-next-line
  return escaped.replace(/[-\/^$*+?.()|[\]{}]/g, '\\$&')
}

export const Category = {
  BULK: { category: 'BULK', name: 'Schoolwide' },
  FREE: { category: 'FREE', name: 'Trial' },
  INDIVIDUAL: { category: 'INDIVIDUAL', name: 'Individual' },
}

export const ProductType = {
  BPU: { skuCode: 'BPU', name: 'Bullying Prevention Unit' },
  CPU: { skuCode: 'CPU', name: 'Child Protection Unit' },
  MSP: { skuCode: 'MSP', name: 'Middle School' },
}

export const sortArrayBy = (arr, property) => {
  arr.sort((a, b) => {
    const aValue = a[property] || a
    const bValue = b[property] || b
    return aValue.localeCompare(bValue)
  })
}

const teacher = {
  role: 'teacher',
  friendlyName: 'Teacher',
  name: 'Teacher',
  article: 'a',
  plural: 's',
}
const admin = {
  role: 'ADMIN',
  friendlyName: 'Administrator',
  name: 'Admin',
  article: 'an',
  plural: 's',
}
const leaderTeam = {
  role: 'Leader Team',
  friendlyName: 'Leader Team',
  name: 'Leader Team',
  article: 'a',
  plural: '',
}
const staff = {
  role: 'staff',
  friendlyName: 'Staff',
  name: 'Staff',
  article: 'a',
  plural: '',
}
const coordinator = {
  role: 'coordinator',
  friendlyName: 'Coordinator',
  name: 'Coordinator',
  article: 'a',
  plural: 's',
}
const siteLeader = {
  role: 'site leader',
  friendlyName: 'Site Leader',
  name: 'Site Leader',
  article: 'a',
  plural: 's',
}
const family = {
  role: 'Family',
  friendlyName: 'Family',
  name: 'Family',
  article: 'a',
  plural: '',
}

export const AccessLevel = {
  Setup: { role: 'SETUP', name: 'Setup', article: 'a' },
  User: { role: 'USER', name: 'User', article: 'a' },
  PTK: { role: 'PTK', name: 'Principal Toolkit User', article: 'a' },
  teacher,
  Teacher: teacher,
  admin,
  Admin: admin,
  'leader team': leaderTeam,
  'Leader Team': leaderTeam,
  staff,
  Staff: staff,
  coordinator,
  Coordinator: coordinator,
  'site leader': siteLeader,
  'Site Leader': siteLeader,
  family,
}

export const licenseTypeUsers = {
  ADL: [
    AccessLevel['site leader'].name,
    AccessLevel['leader team'].name,
    AccessLevel.staff.name,
  ],
  BPU: [AccessLevel.admin.name, AccessLevel.teacher.name],
  CPU: [AccessLevel.admin.name, AccessLevel.teacher.name],
  HSP: [AccessLevel.admin.name, AccessLevel.teacher.name],
  K8P: [AccessLevel.admin.name, AccessLevel.teacher.name],
  MSP: [AccessLevel.admin.name, AccessLevel.teacher.name],
  K8PF: [AccessLevel.family.name, AccessLevel.family.name],
}

export const InvitationStatus = {
  INV: 'Invited',
  CAN: 'Cancelled',
  ACT: 'Active',
  RMD: 'Removed',
  Invited: 'Invited',
  Cancelled: 'Cancelled',
  Active: 'Active',
  Removed: 'Removed',
  None: null,
}

export const selectUsers = (
  license,
  accessLevel,
  ignoreStatus = [InvitationStatus.Cancelled],
  email = '',
) => {
  let users = []
  switch (accessLevel.role) {
    case AccessLevel.Setup.role:
      users = [license.setupAdminEmail]
      break

    case AccessLevel.User.role:
      users = [...license.users] || []
      break

    case AccessLevel.Admin.role:
      users = [...license.admins] || []
      break

    case AccessLevel.PTK.role:
      users = [...license.ptkUsers] || []
      break

    default:
      return []
  }

  const result = []
  for (let i = 0; i < users.length; i++) {
    if (
      ignoreStatus.indexOf(users[i].invitationStatus) < 0 &&
      (!email || users.filter(u => u.email === email).length >= 0)
    )
      result.push(users[i])
  }
  return result
}

export const inputModeType = {
  single: 'single',
  bulk: 'bulk',
}

export const RolesInfo = {
  K8P: [
    {
      id: 'Teacher',
      name: 'Teacher',
      description: 'Can create classes and teach lessons',
    },
    {
      id: 'Admin',
      name: 'Administrator',
      description:
        'Can add, remove and change users, access progress reports, create classes and teach lessons',
    },
  ],
  MSP: [
    {
      id: 'Teacher',
      name: 'Teacher',
      description: 'Can create classes and teach lessons',
    },
    {
      id: 'Admin',
      name: 'Administrator',
      description:
        'Can add, remove and change users, access progress reports, create classes and teach lessons',
    },
  ],
  SSP: [
    {
      id: 'Teacher',
      name: 'Teacher',
      description: 'TBD',
    },
    {
      id: 'Coordinator',
      name: 'Coordinator',
      description: 'TBD',
    },
    {
      id: 'Family',
      name: 'Family',
      description: 'TBD',
    },
  ],
  ADL: [
    {
      id: 'Staff',
      name: 'Staff',
      description: 'Can only view Staff track',
    },
    {
      id: 'Leader Team',
      name: 'Leader Team',
      description: 'Can view Leader Team and Staff tracks',
    },
    {
      id: 'Site Leader',
      name: 'Site Leader',
      description:
        'Can add and remove users, change user roles, view reports, and view Leader Team and Staff tracks',
    },
  ],
  HSP: [
    {
      id: 'Teacher',
      name: 'Teacher',
      description: 'Can create classes and teach lessons',
    },
    {
      id: 'Admin',
      name: 'Administrator',
      description:
        'Can add, remove and change users, access progress reports, create classes and teach lessons',
    },
  ],
  OST: [
    {
      id: 'Teacher',
      name: 'Teacher',
      description: 'TBD',
    },
  ],
  BPU: [
    {
      id: 'Teacher',
      name: 'Teacher',
      description: 'Can access online training',
    },
    {
      id: 'Admin',
      name: 'Administrator',
      description:
        'Can add, remove, and change users, view reports, and access online training',
    },
    {
      id: 'Coordinator',
      name: 'Coordinator',
      description: 'TBD',
    },
    {
      id: 'Family',
      name: 'Family',
      description: 'TBD',
    },
  ],
  CPU: [
    {
      id: 'Teacher',
      name: 'Teacher',
      description: 'Can access online training',
    },
    {
      id: 'Admin',
      name: 'Administrator',
      description:
        'Can add, remove, and change users, view reports, and access online training',
    },
    {
      id: 'Coordinator',
      name: 'Coordinator',
      description: 'TBD',
    },
    {
      id: 'Family',
      name: 'Family',
      description: 'TBD',
    },
  ],
  K8PF: [
    {
      id: 'Family',
      name: 'Family',
      description: 'Can view Family Access content',
    },
  ],
}

export const getTextFromGrade = grade => {
  switch (grade) {
    case 'E':
      return 'early-learning'
    case 'K':
      return 'kindergarten'
    case '1':
      return 'grade 1'
    case '2':
      return 'grade 2'
    case '3':
      return 'grade 3'
    case '4':
      return 'grade 4'
    case '5':
      return 'grade 5'
    case '6':
      return 'grade 6'
    case '7':
      return 'grade 7'
    case '8':
      return 'grade 8'
    default:
      return grade
  }
}

export const displayDate = (date, format = 'MMMM DD, YYYY') => {
  if (!date) {
    return ''
  }
  const formattedDate = moment(date).format(format)
  return formattedDate
}

export const getProductAccess = (licenses = [], currentUserEmail) => {
  const result = new Map()

  for (let i = 0; i < licenses.length; i++) {
    const skuCode = licenses[i].skuCode
    const expiration = extractExpirationInfo(licenses[i])

    // short-circuits for BPU/CPU, canceled licenses, and expiration
    if (skuCode !== ProductType.MSP.skuCode || expiration.isExpired) continue

    const hasAccess =
      selectUsers(
        licenses[i],
        AccessLevel.User,
        [InvitationStatus.Canceled],
        currentUserEmail,
      ).length > 0

    if (hasAccess) {
      result.set(
        skuCode,
        new Set([...(result.get(skuCode) || []), AccessLevel.User.role]),
      )
    }

    if (skuCode === ProductType.MSP.skuCode) {
      const hasAccess =
        selectUsers(
          licenses[i],
          AccessLevel.PTK,
          [InvitationStatus.Canceled],
          currentUserEmail,
        ).length > 0

      if (hasAccess)
        result.set(
          skuCode,
          new Set([...(result.get(skuCode) || []), AccessLevel.PTK.role]),
        )
    }
  }
  return result
}

export const hasProductUnlimited = (licenses, product) => {
  for (let i = 0; i < licenses.length; i++) {
    const skuCode = licenses[i].skuCode
    const productType = product.toUpperCase()
    if (skuCode === productType) return true
  }

  return false
}

export const validateEmail = email => {
  // eslint-disable-next-line
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

export const validatePak = async pakNumber => {
  if (pakNumber.length !== 12) return false
  try {
    await api.post(`/pak/validate`, { pakNumber })
    return true
  } catch (error) {
    if (error.status !== 400) {
      console.error('error in pak validation')
      console.error(error)
    }
    return false
  }
}

export const userLimit = (license, accessLevel) => {
  //NOTE: 0 === none, false/null === unlimited
  switch (accessLevel.role) {
    case AccessLevel.User.role:
      return license.maxSeatCount || false

    case AccessLevel.Admin.role:
      return false

    case AccessLevel.PTK.role:
      return license.maxPtkCount || false

    default:
      return false
  }
}

export const extractExpirationInfo = (obj, format = 'MMMM DD, YYYY') => {
  const startDate = obj.startDate ? moment(obj.startDate) : null
  const cancellationDate = obj.cancelledDate
    ? moment(obj.cancelledDate)
    : undefined
  const expirationDate = obj.expirationDate
    ? moment(obj.expirationDate)
    : undefined
  const date =
    obj.cancelledDate && cancellationDate < expirationDate
      ? cancellationDate
      : expirationDate
  const now = moment.utc()
  const isExpired = date <= now
  const daysLeft = Math.max(0, date && date.diff(now, 'days'))
  let icon = ''
  if (date <= now) icon = <i className="fa fa-times-circle text-danger" />
  else if (daysLeft <= 90)
    icon = <i className="fa fa-exclamation-triangle text-warning" />

  return {
    now: now,
    startDate: {
      native: obj.startDate,
      moment: startDate,
      formatted: obj.startDate ? startDate.format(format) : null,
    },
    expirationDate: {
      native: obj.expirationDate,
      moment: expirationDate,
      formatted: obj.expirationDate ? expirationDate.format(format) : null,
    },
    cancelledDate: {
      native: obj.cancelledDate,
      moment: obj.cancelledDate ? cancellationDate : null,
      formatted: obj.cancelledDate ? cancellationDate.format(format) : null,
    },
    effectiveEndDate: {
      moment: date,
      formatted: date && date.format(format),
    },
    format: format,
    isExpired: isExpired,
    isExpiringSoon: !isExpired && daysLeft <= 90,
    expirationWarningThresholdDays: 90,
    daysLeft: daysLeft,
    label: isExpired ? 'Expired on ' : 'Expires on ',
    icon: icon,
  }
}

// SelectLookup Helpers
export const formatUserSuggestion = user => {
  return {
    value: user.email,
    label: `${user.email} - ${user.firstName} ${user.lastName}`,
    ...user,
  }
}

export const formatSchoolSuggestion = school => {
  return {
    value: school.mdrpid,
    label: `${school.name} - ${school.mdrpid}`,
    ...school,
  }
}

export const capitalize = string =>
  string.replace(/(\b[a-z](?!\s))/g, char => char.toUpperCase())

export const uncapitalize = string =>
  string.replace(/(\b[a-z](?!\s))/g, char => char.toLowerCase())

export const addUserToLicense = (license, newUser) => {
  const formattedUser = {
    name: newUser.userName || newUser.email,
    email: newUser.email,
    roles: newUser.roles,
    invitationStatus: newUser.status,
    licenseId: newUser.licenseId,
    userId: newUser.userId,
    sent: newUser.inviteDate,
  }
  const { users } = license
  const userIndex = users.findIndex(user => user.email === newUser.email)

  const userExistsAsCancelledOrRemoved = userIndex !== -1

  if (userExistsAsCancelledOrRemoved) {
    users[userIndex] = formattedUser
  } else {
    users.push(formattedUser)
  }
}

export const getCookie = cname => {
  const name = `${cname}=`
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export const setCookie = (cname, cvalue, exdays) => {
  const d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  const expires = `expires=${d.toUTCString()}`
  document.cookie = `${cname}=${cvalue};${expires};path=/`
}

export const getNestedObject = (nestedObj, pathString) => {
  const paths = pathString.split('.')
  return paths.reduce(
    (obj, key) => (obj && obj[key] !== 'undefined' ? obj[key] : undefined),
    nestedObj,
  )
}

const hasSela = licenses => {
  const programCodes = licenses.reduce(
    (acc, license) => acc.concat(license.product.programCodes),
    [],
  )
  return programCodes.indexOf('ADL') > -1
}

const siteRoles = [admin, leaderTeam, teacher]

export const getSitesApplicableRoles = site => {
  if (site && hasSela(site.licenses)) {
    return siteRoles
  }

  return siteRoles.filter(role => role.name !== leaderTeam.friendlyName)
}

export const filterCanceledUsers = (siteUsers = []) =>
  siteUsers &&
  siteUsers.filter(
    ({ status }) =>
      status !== InvitationStatus.Cancelled &&
      status !== InvitationStatus.Removed,
  )
export const AddUsersRolesInfo = {
  ADL: [
    {
      role: 'Teacher',
      id: 'Teacher',
      description: [
        'Can view and teach lessons',
        'Can access microlearnings',
        'Can access online training',
      ],
    },
    {
      role: 'Leader Team',
      id: 'Leader Team',
      description: [
        'Can view and teach lessons',
        'Can access microlearnings',
        'Can access Leader supports',
        'Can access online training',
      ],
    },
    {
      role: 'Administrator',
      id: 'Admin',
      description: [
        'Can manage users',
        'Can view reports',
        'Can view and teach lessons',
        'Can access microlearnings',
        'Can access Leader supports',
        'Can access online training',
      ],
    },
  ],
  Default: [
    {
      role: 'Teacher',
      id: 'Teacher',
      description: ['Can view and teach lessons', 'Can access online training'],
    },
    {
      role: 'Administrator',
      id: 'Admin',
      description: [
        'Can manage users',
        'Can view reports',
        'Can view and teach lessons',
        'Can access online training',
      ],
    },
  ],
}

export const sortFailedSiteUsers = (selectedSiteUsers, failedSiteUsers) => {
  const existingUsers = []
  const invalidUsers = []
  const selectedSiteUserEmails = new Set(
    selectedSiteUsers.map(user => user.inviteEmail),
  )

  failedSiteUsers.forEach(user => {
    selectedSiteUserEmails.has(user.inviteEmail)
      ? existingUsers.push(user.inviteEmail)
      : invalidUsers.push(user.inviteEmail)
  })
  return {
    existingUsers,
    invalidUsers,
  }
}

export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const validateBulkEmails = emailsString => {
  // Split the string by commas, semicolons, or new lines
  const emailArray = emailsString.split(/[\n,;]+/).map(email => email.trim())

  const validEmails = []
  const invalidEmails = []

  emailArray.forEach(email => {
    if (emailRegex.test(email)) {
      validEmails.push(email)
    } else {
      invalidEmails.push(email)
    }
  })

  return {
    validEmails,
    invalidEmails,
  }
}

export const pluralize = (number, word, plural = word + 's') => {
  const isSingular = [1, -1].includes(Number(number))
  return isSingular ? word : plural
}

export const UpdateSiteUserNotifications = {
  grantNewRole: {
    operationName: 'grantNewRole',
    successMessage: ({ email, role }) =>
      `You've successfully granted the ${role} role to ${email}.`,
    errorMessage: ({ email, role }) =>
      `We weren't able to grant the ${role} role to ${email}. Please try again later.`,
  },
  removeUser: {
    operationName: 'removeUser',
    successMessage: ({ email }) => `You've successfully removed ${email}.`,
    errorMessage: ({ email }) =>
      `We weren't able to remove ${email}. Please try again later.`,
  },
}



// WEBPACK FOOTER //
// ./src/lib/util.js